import classNames from 'classnames';
import { FC } from 'react';
import Button from '../Button/Button';
import { ButtonVariants } from '../Button/Button.types';
import Tooltip from '../Tooltip/Tooltip';
import styles from './SummaryBlock.module.css';
import { SummaryBlockProps } from './SummaryBlock.types';

const SummaryBlock: FC<SummaryBlockProps> = ({ blocks, title, className, variant, tooltipText }) => (
  <div className={classNames(styles.container, { [styles.withTooltip]: tooltipText !== undefined })}>
    {title && (
      <div className={classNames(styles.title, { [styles.withTooltip]: tooltipText !== undefined })}>
        {title}
        {tooltipText && <Tooltip content={tooltipText} />}
      </div>
    )}
    <div
      data-testid="SummaryBlock"
      className={classNames(styles.card, {
        [styles.emphasis]: variant !== undefined,
        [styles.withCount]: blocks?.[0]?.count !== undefined,
        [styles[variant!]]: variant !== undefined,
        [className!]: className !== undefined,
        [styles.multiBlock]: blocks.length > 1,
        [styles.withLabel]: blocks?.[0]?.label !== undefined,
      })}
    >
      {blocks.map(({ count, label, buttonText, onButtonClick }, index) => (
        <div
          key={label || index}
          className={classNames(styles.blockContent, {
            // include a divider between sections if it's not the only block or not the last block
            [styles.rightBorder]: blocks.length !== 1 && index !== blocks.length - 1,
            [styles.maxWidth]: blocks.length > 1,
          })}
        >
          {count !== undefined && (
            <div className={styles.count} data-testid="summaryBlockCount">
              {count}
            </div>
          )}
          <div className={styles.label}>{label}</div>
          {buttonText && onButtonClick && (
            <Button variant={ButtonVariants.Text} onClick={onButtonClick}>
              {buttonText}
            </Button>
          )}
        </div>
      ))}
      {blocks.length === 0 && (
        <div className={styles.noBlocksMessage}>Try adding a Block to the &quot;blocks&quot; prop</div>
      )}
    </div>
  </div>
);

export default SummaryBlock;
